import React from 'react';
import { Field } from 'react-final-form';
import CustomInputField from '../../../../components/form/CustomInputField';
import CustomSelect from '../../../../components/form/CustomSelect';
import { useDict } from '../../../../contexts/LanguageContext';

const EmployedSelected = ({
    submitted,
    jobCategory,
    title,
    annualIncome,
    netWorth,
}) => {
    const dict = useDict();

    return (
        <span style={{ width: '100%' }}>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.companyName}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="company_name">
                            {({ input, meta }) => (
                                <CustomInputField
                                    input={input}
                                    meta={meta}
                                    submitted={submitted}
                                    autoFocus
                                    type="text"
                                    style={{}}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.jobCategory}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="job_category_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={jobCategory}
                                    placeholder={dict.selectJobCategory}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.annualEmploymentIncome}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="annual_income">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={annualIncome}
                                    placeholder={
                                        dict.selectAnnualEmploymentIncome
                                    }
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.netWorth}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="networth_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={netWorth}
                                    placeholder={dict.selectNetWorth}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </span>
    );
};

EmployedSelected.defaultProps = {
    submitted: false,
    jobCategory: [],
    title: [],
    annualIncome: [],
    netWorth: [],
};

export default EmployedSelected;
